
<template>
  <div class="container">
    <div class="row">
      <div class="col-md-12">
        <div class="table-responsive">
            <h2>{{ msg }}</h2>
             <input type="text" class="search" v-model="searchKey" placeholder="Sök.."/>
          <div class="clearfix btn-group col-md-2">
            <button type="button" class="btn btn-sm" v-if="page != 1" @click="page=1"> &lt;&lt;</button>
            <button type="button" class="btn btn-sm" v-if="page != 1" @click="page--"> &lt; </button>
            <button type="button" class="btn btn-sm" v-for="pageNumber in pages.slice(page-1, page+5)" @click="page = pageNumber" :key="pageNumber"> {{pageNumber}} </button>
            <button type="button" @click="page++" v-if="page < pages.length" class="btn btn-sm"> &gt; </button>
            <button type="button" @click="page = pages.length -1" v-if="page < pages.length" class="btn btn-sm"> &gt;&gt; </button>
          </div>
         <table class="table-hover orderList" v-if="customersPlaces">
            <thead>
              <tr>
                <th v-for="customersPlacesSchemaField in activeColumns" :key="customersPlacesSchemaField.label">
                  {{customersPlacesSchemaField.label}}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="customerPlace in displayedPosts" :key="customerPlace.id" v-on:click="customerPlacesDetails(customerPlace)">
                <td v-for="customersPlacesSchemaField in activeColumns" :key="customersPlacesSchemaField.label">
                 {{customerPlace.data[customersPlacesSchemaField.model]}}
                </td>
              </tr>
            </tbody>
          </table>
           <div class="clearfix btn-group col-md-2">
            <button type="button" class="btn btn-sm" v-if="page != 1" @click="page=1"> &lt;&lt;</button>
            <button type="button" class="btn btn-sm" v-if="page != 1" @click="page--"> &lt; </button>
            <button type="button" class="btn btn-sm" v-for="pageNumber in pages.slice(page-1, page+5)" @click="page = pageNumber" :key="pageNumber"> {{pageNumber}} </button>
            <button type="button" @click="page++" v-if="page < pages.length" class="btn btn-sm"> &gt; </button>
            <button type="button" @click="page = pages.length -1" v-if="page < pages.length" class="btn btn-sm"> &gt;&gt; </button>
          </div>
        </div>
      </div>
    </div>
    <div class="row marginBottom">
      <div class="col-md-12">
        <Button label="Skapa ny" @click="createDetails()" icon="pi pi-plus" ></Button>
        <Button :label="inActiveBtnText" @click="showInactive()" icon="pi pi-eye" ></Button><br/><br/>
      </div>
    </div>
    <div class="row">
      <div class="col-md-12">
        <CsvImport />
      </div>
    </div>
  </div>
</template>

<script>
import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import CsvImport from '@/components/ImportData/CsvImport'
import { bus } from '../../main'
import Button from 'primevue/button'
export default {
  name: 'CustomersPlacesList',
  data () {
    return {
      msg: 'Leveransställen',
      customersPlaces: [],
      customersPlacesSchema: {},
      page: 1,
      perPage: 20,
      pages: [],
      searchKey: '',
      unknownArticles: null,
      inActiveBtnText: 'Visa inaktiva',
      showFilteredObjects: false
    }
  },
  components: {
    CsvImport,
    DataTable,
    Column,
    Button
  },
  props: {
    customerId: Number,
    searchval: String
  },
  watch: {
    customerId: function (newVal, oldVal) {
      this.$props.customerId = newVal
    }
  },
  created () {
    bus.$on('addedPlace', obj => {
      this.customersPlaces.push(obj)
    })
  },
  mounted () {
    if (this.$props.customerId === undefined) {
      this.fetchAllCustomerPlaces()
    } else {
      this.fetchCustomerPlacesByCustomer()
    }
    this.searchKey = this.$props.searchval === undefined ? '' : this.$props.searchval
  },
  computed: {
    activeColumns: function () {
      return this.customersPlacesSchema.fields && this.customersPlacesSchema.fields.filter(function (c) {
        return c.showInList
      })
    },
    displayedPosts () {
      return this.paginate(this.customersPlaces.filter(places => {
        for (let key in places.data) {
          if (key !== 'vismaData' && key !== 'longitude' && key !== 'latitude' && key !== 'artnr' && places.data[key].toString().toLowerCase().includes(this.searchKey.toLowerCase())) {
            if (this.showFilteredObjects) {
              if (places.data.inActive) {
                return true
              }
            } else {
              if (places.data.inActive === undefined || places.data.inActive === false) {
                return true
              }
            }
          }
        }
      }))
    }
  },
  methods: {
    createDetails () {
      this.$router.push({ name: 'CustomerPlacesCreate', params: { schema: this.customersPlacesSchema } })
    },
    setPages (customerPlaces) {
      let numberOfPages = Math.ceil(customerPlaces.length / this.perPage)
      this.pages = []
      for (let index = 1; index <= numberOfPages; index++) {
        this.pages.push(index)
      }
    },
    paginate (posts) {
      let page = this.page
      let perPage = this.perPage
      let from = (page * perPage) - perPage
      let to = (page * perPage)
      this.setPages(posts)
      if (this.searchKey !== '') {
        this.page = 1
      }
      return posts.slice(from, to)
    },
    customerPlacesDetails (customerPlace) {
      this.$router.push({ name: 'CustomerPlacesDetails', params: { id: customerPlace.id, customerPlace: customerPlace, searchval: this.searchKey } })
    },
    fetchAllCustomerPlaces () {
      this.$http
        .get('/api/customersplaces')
        .then(response => {
          this.customersPlaces = response.data.customersplace
          this.customersPlacesSchema = response.data.schema
        })
        .catch(error => console.log(error))
    },
    fetchCustomerPlacesByCustomer () {
      this.$http
        .get('/api/customersplaces/customer/' + this.customerId)
        .then(response => {
          this.customersPlaces = response.data.customersplaces
          this.customersPlacesSchema = response.data.schema
        })
        .catch(error => console.log(error))
    },
    showInactive () {
      if (this.showFilteredObjects) {
        this.showFilteredObjects = false
        this.inActiveBtnText = 'Visa inaktiva'
      } else {
        this.showFilteredObjects = true
        this.inActiveBtnText = 'Visa alla'
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Customers/CustomerPlacesList.vue